import React from "react";
import { ABOUT_BULLETS } from "../../lib/publicSite";

export default function About() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <div className="grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h1 className="font-display font-bold text-3xl sm:text-4xl">About VastraKiran</h1>
          <p className="mt-4 text-lg leading-relaxed" style={{ color: "var(--text-muted)" }}>
            We built VastraKiran for home-run saree and dress boutiques across India — owners who still track stock in notebooks, bill on calculators, and lose track of which piece sold last week.
          </p>
          <p className="mt-4 leading-relaxed" style={{ color: "var(--text-muted)" }}>
            Our goal is simple: barcode every piece once, scan to bill at the counter, and see today&apos;s revenue without opening Excel. GST-ready invoices, customer register, staff attendance — everything in one place, in rupees, on any phone or laptop.
          </p>
        </div>
        <div className="card-soft p-8">
          <div className="font-display font-semibold text-xl mb-4">Why boutiques choose us</div>
          <ul className="space-y-3 text-sm">
            {ABOUT_BULLETS.map((line) => (
              <li key={line} className="flex items-start gap-2">
                <span style={{ color: "var(--primary)" }}>✓</span>
                <span style={{ color: "var(--text-muted)" }}>{line}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
